const DocEditIcon = (props: any) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="24"
        height="24"
        rx="2"
        fill="var(--primary)"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.33008 18.75H9.42036C9.76555 18.75 10.0454 19.0298 10.0454 19.375C10.0454 19.7202 9.76555 20 9.42036 20H7.33008C5.95158 20 4.83008 18.8785 4.83008 17.5V6.5C4.83008 5.1215 5.95158 4 7.33008 4H15.0141C16.3926 4 17.5141 5.1215 17.5141 6.5V10.3438C17.5141 10.6889 17.2343 10.9688 16.8891 10.9688C16.5439 10.9688 16.2641 10.6889 16.2641 10.3438V6.5C16.2641 5.81075 15.7034 5.25 15.0141 5.25H7.33008C6.64083 5.25 6.08008 5.81075 6.08008 6.5V17.5C6.08008 18.1892 6.64083 18.75 7.33008 18.75ZM15.0156 10.875C15.0156 10.5298 14.7358 10.25 14.3906 10.25H7.95313C7.60794 10.25 7.32812 10.5298 7.32812 10.875C7.32812 11.2202 7.60794 11.5 7.95313 11.5H14.3906C14.7358 11.5 15.0156 11.2202 15.0156 10.875ZM7.95312 12.75C7.60794 12.75 7.32812 13.0298 7.32812 13.375C7.32812 13.7202 7.60794 14 7.95312 14H11.8628C12.208 14 12.4878 13.7202 12.4878 13.375C12.4878 13.0298 12.208 12.75 11.8628 12.75H7.95312ZM18.6227 13.0493C17.8917 12.3183 16.7022 12.3183 15.9716 13.0488L12.5402 16.4726C12.4673 16.5453 12.4136 16.6349 12.3837 16.7334L11.6364 19.1935C11.5701 19.4117 11.6278 19.6485 11.787 19.8117C11.9063 19.9339 12.0683 20.0002 12.2344 20.0002C12.29 20.0002 12.3462 19.9928 12.4012 19.9775L14.9239 19.2787C15.0277 19.25 15.1223 19.1949 15.1986 19.1187L18.6227 15.701C19.3538 14.97 19.3538 13.7805 18.6227 13.0493ZM14.4318 18.118L13.1627 18.4695L13.5341 17.2468L15.8494 14.9366L16.7335 15.8207L14.4318 18.118ZM17.7393 14.8168L17.6182 14.9376L16.7343 14.0537L16.855 13.9333C17.0987 13.6896 17.4952 13.6896 17.7389 13.9333C17.9826 14.177 17.9826 14.5735 17.7393 14.8168ZM7.95313 7.75H14.3906C14.7358 7.75 15.0156 8.02981 15.0156 8.375C15.0156 8.72019 14.7358 9 14.3906 9H7.95313C7.60794 9 7.32812 8.72019 7.32812 8.375C7.32812 8.02981 7.60794 7.75 7.95313 7.75Z"
        fill="var(--primary)"
      />
    </svg>
  );
};

export default DocEditIcon;
